import { Mixin } from "@/mixin";

const set = (key) => (state, val) => {
  state[key] = val;
};

function initialState() {
  return {
    lines: [], // لیست یوزرنیم‌های واتساپ
    total: 0,
    query: {},
    loading: false,
  };
}

const getters = {
  socialLines: (state) => state.lines,
  socialTotal: (state) => state.total,
  socialLoading: (state) => state.loading,
};

const actions = {
  fetchSocialOperators({ commit }) {
    commit("setLoading", true);

    Mixin.methods
      .requestApiGetPayamak("social/data")
      .then((response) => {
        const rawItems = response?.data?.data.data || [];

        const reformat = rawItems
          .filter((op) => op.status === "accept")
          .map((op) => {
            let label = `${op.username}`;

            // if (op.status)
            //   label += ` (${op.status === "accept" ? "فعال" : "غیرفعال"})`;
            // if (op.max_sends) label += ` - حداکثر ارسال: ${op.max_sends}`;
            // if (op.count_sends) label += ` (ارسال شده: ${op.count_sends})`;
            if (op.max_sends && op.count_sends)
              label += ` - اعتبار ارسال باقی‌مانده: ${
                op.max_sends - op.count_sends
              }`;
            else if (op.max_sends)
              label += ` - اعتبار ارسال باقی‌مانده: ${op.max_sends}`;

            const color =
              op.status === "accept"
                ? "#2e7d32"
                : op.status === "pending"
                ? "#ef6c00" // نارنجی برای در انتظار
                : "#c62828"; // قرمز برای غیرفعال/رد شده

            const coloredText = `<span style="color: ${color};">${label.trim()}</span>`;

            return {
              value: op.username,
              text: coloredText,
              raw: op,
            };
          });

        commit("setLines", reformat);
        commit("setTotal", response.data.total || reformat.length);
      })
      .catch((err) => {
        console.error("خطا در بارگذاری اپراتورهای واتساپ:", err);
      })
      .finally(() => commit("setLoading", false));
  },
};

const mutations = {
  setLines: set("lines"),
  setTotal: set("total"),
  setLoading: set("loading"),
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
